import { featureOn } from '@/helpers/entitlements'

export const INVOICING_FEATURE = 'invoicing'
// BOT-1697: invoicing is a plan feature; the capability is only read while Rails sends no payload.
export const hasInvoicing = user => featureOn(user, INVOICING_FEATURE)
